import { render, staticRenderFns } from "./kayttajahallinta.vue?vue&type=template&id=e64201ac&scoped=true&"
import script from "./kayttajahallinta.vue?vue&type=script&lang=ts&"
export * from "./kayttajahallinta.vue?vue&type=script&lang=ts&"
import style0 from "./kayttajahallinta.vue?vue&type=style&index=0&id=e64201ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64201ac",
  null
  
)

export default component.exports